<template>
  <header class="sticky top-0 z-40 bg-soft-white/90 backdrop-blur border-b border-light-purple/10">
    <div class="container mx-auto px-6 py-3 flex items-center justify-between gap-4">
      <RouterLink to="/" class="font-poppins font-bold text-2xl text-light-purple">
        Homvisit
      </RouterLink>

      <nav class="hidden lg:flex items-center gap-5 text-sm font-medium text-dark-gray/80">
        <RouterLink class="hover:text-light-purple" to="/services">Services</RouterLink>
        <RouterLink class="hover:text-light-purple" to="/services/corporate-health-camps">Camps</RouterLink>
        <RouterLink class="hover:text-light-purple" to="/insights">Insights</RouterLink>
        <RouterLink class="hover:text-light-purple" to="/resources">Resources</RouterLink>
        <RouterLink class="hover:text-light-purple" to="/jobs">Jobs</RouterLink>
        <a class="hover:text-light-purple" href="/#contact">Contact</a>
      </nav>

      <div class="flex items-center gap-2">
        <a
          :href="`tel:${phoneTel}`"
          class="hidden sm:inline text-sm font-semibold text-dark-gray hover:text-light-purple"
        >
          {{ phoneDisplay }}
        </a>
        <RouterLink
          to="/services/phlebotomy-services-kerala"
          class="px-4 py-2 rounded-full bg-light-purple text-white text-sm font-semibold shadow-soft hover:opacity-90"
        >
          Get quote
        </RouterLink>
      </div>
    </div>
  </header>
</template>

<script>
import { CONTACT_PHONE_DISPLAY, CONTACT_PHONE_TEL } from '../config/contact'

export default {
  name: 'SiteHeader',
  setup() {
    return {
      phoneDisplay: CONTACT_PHONE_DISPLAY,
      phoneTel: CONTACT_PHONE_TEL,
    }
  },
}
</script>
